var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dg-youtube-playlist[data-v-56fc6f98]{background:var(--primary-dark);padding:0 15px}.dg-youtube-playlist[data-brand=mazda][data-v-56fc6f98]{background:#fff;padding:30px 15px}.dg-youtube-playlist .youtube-container[data-v-56fc6f98]{max-width:800px;margin:auto}.dg-youtube-playlist .youtube-container .embed-responsive[data-v-56fc6f98]{background-image:url(" + escape(require("../../static/images/youtube-backup-bg.png")) + ");background-size:cover;background-position:50%}", ""]);

// exports
